// Reserved /embedded/:integrationId values that select a sidebar page instead
// of an integration detail (mirrors how /apps/:appId doubles as a selector).
export const EMBEDDED_SUBPAGES = ['sdk', 'integrations', 'connections', 'workflows', 'api', 'credential-exchange', 'mcp'];

export const isEmbeddedSubpage = (value) => EMBEDDED_SUBPAGES.includes(value);
